<template>
  <div class="view valet-login">
    <h6>{{ $t('registration.breadcrumb') }}</h6>
    <form v-if="!verified">
      <div class="group">
        <Input
          type="text"
          :placeholder="$t('valet.login.user')"
          :value.sync="user"
          required
        />
      </div>
      <div class="group">
        <Input
          type="password"
          :placeholder="$t('valet.login.pass')"
          :value.sync="pass"
          required
        />
      </div>
      <div class="group">
        <Button use-arrow fullwidth @click="handleFormSubmit">{{ $t('valet.login.button') }}</Button>
      </div>
    </form>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import Input from '@/components/Input';

  const sjcl = require('sjcl');

  export default {
    name: 'ValetLogin',
    components: {
      Input,
      Button,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        user: null,
        pass: null,
        verified: true,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    created() {
      if (this.$b.data.verified) {
        this.$router.push(`/${this.$i18n.locale}/valet/overview`);
      }
      this.verified = this.$b.data.verified;
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleFormSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.user && this.pass) {
          const response = await this.$b.api.post('global/login', null, {
            user: this.user,
            hash: sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(`mmd${sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(this.pass))}`)),
          });
          if (response.verified) {
            this.$router.push(`/${this.$i18n.locale}/valet/overview`);
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .view.valet-login {
    padding: 25px 20px 0 20px;

    h1 {
      position: relative;
      @include font-daimler-cac();
      font-size: 3.4rem;
      margin: 0 0 55px;
      padding: 0;
    }
    h3 {
      @include font-daimler-cac();
      font-size: 2.8rem;
      margin: 45px 0 0 0;
      padding: 0;
    }
    h6 {
      position: relative;
      @include font-daimler-cs(400);
      font-size: 1.6rem;
      margin: 0;
      padding: 0;

      &:after {
        content: '';
        position: relative;
        display: block;
        height: 2px;
        width: 46px;
        background-color: $color-white;
        margin-top: 25px;
        margin-bottom: 30px;
      }
    }

    a {
      color: $color-gray;
      cursor: pointer;

      span.link {
        display: inline-block;
        &:before {
          display: inline-block;
          position: relative;
          content: '>';
          width: auto;
          height: inherit;
          margin-right: 8px;
          transform-origin: 50% 50%;
          transform: translate(0,1px) rotate(0) scale(1, 1.6);
        }
      }
    }

    form {
      max-width: 258px;

      & > div {
        margin-bottom: 16px;
      }
    }
  }
</style>
